import { gql } from 'graphql-request'

export const GET_LINE_INFORMATION = gql`
  query GetLineInformation($token: String!) {
    getLineInformation(token: $token) {
      email
    }
  }
`
